import React from 'react'

import './styles.scss'

const BarSelector = props => {
  const { options, value, onChange } = props

  if (!options?.length) return null

  return (
    <div className='inchat-section-bar-selector'>
      {options.map((option, index) => (
        <span
          key={index}
          className={`
            inchat-section-bar-selector__option
            ${option.id === value ? 'inchat-section-bar-selector__option--active' : ''}
          `}
          onClick={() => onChange(option)}
        >
          {option.name}
        </span>
      ))}
    </div>
  )
}

export default BarSelector
